/**
 * Generated runtime TestId mirror for frontend/src/pages/reporting/CategoryPickerDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CategoryPickerDialogTestIds = {
  btnClearPickerSearch: "btn-clear-picker-search",
  none: "none",
  btnPickerRow: (isNoneOption____none____label: string) => `btn-picker-row-${isNoneOption____none____label}`,
  btnPickerRowPrefix: () => "btn-picker-row-" as TestIdPrefix
} as const;
